var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ais-index',{attrs:{"index-name":_vm.indexNames,"searchClient":_vm.customSearchClient}},[_c('search-engine-page',{attrs:{"searchPanel":"wiki"}}),_c('entity-page')],1)}
var staticRenderFns = []

export { render, staticRenderFns }